import { useEffect, useState, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import API, { apiError } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { RecordList } from '../../components/erp/RecordList';
import { ErpHeading } from '../../components/erp/ErpShared';

export default function CatalogsPage() {
  const { permissions } = useOutletContext();
  const [catalogs, setCatalogs] = useState([]);
  const [selected, setSelected] = useState('');
  const [manage, setManage] = useState(false);
  const [error, setError] = useState('');
  const load = useCallback(() => API.get('/erp/records/catalog?page_size=100').then(r => {
    setCatalogs(r.data.items); setSelected(old => r.data.items.some(c => c.id === old) ? old : r.data.items[0]?.id || '');
  }).catch(e => setError(apiError(e))), []);
  useEffect(() => { load(); }, [load]);
  return <><ErpHeading title="Nomenclatoare"><Button variant="outline" onClick={() => setManage(v => !v)} data-testid="catalogs-manage">{manage ? 'Înapoi la valori' : 'Registre'}</Button></ErpHeading>
    {error && <p role="alert" data-testid="catalogs-error">{error}</p>}
    {manage ? <RecordList kind="catalog" canWrite={permissions.includes('catalogs.write')} onChange={load} /> : <>
      <label className="erp-field max-w-md mb-8">Registru<select value={selected} onChange={e => setSelected(e.target.value)} data-testid="catalog-selector">{catalogs.map(c => <option value={c.id} key={c.id}>{c.name}</option>)}</select></label>
      {selected && <RecordList key={selected} kind="master" category={selected} canWrite={permissions.includes('catalogs.write')} />}
    </>}
  </>;
}